import type { ProductFormulation } from '@/constants/products';
import { omitDispenseLimits } from '@/utils/dosageLimit/dispenseLimitsByFormulation';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { setRevalidatedPad } from '../utils/setRevalidatedPad';

/**
 * Drops the set limits of the given formulations, so each falls back to the amount prescribed, and re-validates the
 * items whose dosage text carries the limit.
 */
export const revertFormulationDispenseLimits: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (formulations: ProductFormulation[]) => void
> = (set, get) => (formulations) => {
  const { prescriptionPad, prescriptionPadRules } = get().prescriptionAssistant;
  setRevalidatedPad(
    set,
    { ...prescriptionPad, dispenseLimits: omitDispenseLimits(prescriptionPad.dispenseLimits, formulations) },
    prescriptionPadRules,
    'prescriptionPad/revertFormulationDispenseLimits',
  );
};
